// src/multiselect/src/components/react-select-components/multi-value-label.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var MultiValueLabel = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(components.MultiValueLabel, { ...props, children: /* @__PURE__ */ jsx("span", { className: "contents", "data-testid": "multivalue-label", children }) });
};

export {
  MultiValueLabel
};
